var SET_SHARED_ENV = 'SET_SHARED_ENV';
export default SET_SHARED_ENV;